/**
 * Componente: FiltrosProgramaciones
 *
 * Panel de filtros colapsable para los dos tabs de Programaciones.
 * Soporta modo 'programacion' (Tab 1) y modo 'ot' (Tab 2).
 */

import React, { useState } from 'react';
import { Form, Row, Col, Button, Accordion } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ESTADOS_PROGRAMACION = [
  { value: '', label: 'Todos los estados' },
  { value: 'PROGRAMADO',  label: 'Programado' },
  { value: 'EN_PROCESO', label: 'En Proceso' },
  { value: 'FINALIZADO',  label: 'Finalizado' },
  { value: 'CANCELADO',   label: 'Cancelado' }
];

const ESTADOS_OT = [
  { value: '', label: 'Todos los estados' },
  { value: 'Solicitud',        label: 'Solicitud' },
  { value: 'Programada',       label: 'Programada' },
  { value: 'Abierta',          label: 'Abierta' },
  { value: 'Lista para Cerrar', label: 'Lista para Cerrar' },
  { value: 'Cerrada',          label: 'Cerrada' }
];

const FiltrosProgramaciones = ({
  filters = {},
  onFilterChange,
  onResetFilters,
  mode = 'programacion' // 'programacion' | 'ot'
}) => {
  const [expanded, setExpanded] = useState(false);
  const estados = mode === 'programacion' ? ESTADOS_PROGRAMACION : ESTADOS_OT;

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFilterChange(name, value);
  };

  const activeCount = Object.entries(filters).filter(
    ([k, v]) => !['page', 'perPage'].includes(k) && v !== '' && v !== null && v !== undefined
  ).length;

  return (
    <Accordion className="mb-3">
      <Accordion.Item eventKey="0">
        <Accordion.Header onClick={() => setExpanded(!expanded)}>
          <strong>🔍 Filtros</strong>
          {activeCount > 0 && (
            <span className="badge bg-primary ms-2">{activeCount} activo{activeCount !== 1 ? 's' : ''}</span>
          )}
        </Accordion.Header>
        <Accordion.Body>
          <Form>
            <Row className="mb-3 g-3">
              {/* Número de Orden */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Número de Orden</Form.Label>
                  <Form.Control
                    type="text"
                    name="numeroOrden"
                    value={filters.numeroOrden || ''}
                    onChange={handleChange}
                    placeholder="Buscar..."
                  />
                </Form.Group>
              </Col>

              {/* Estado */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Estado</Form.Label>
                  <Form.Select
                    name="estado"
                    value={filters.estado || ''}
                    onChange={handleChange}
                  >
                    {estados.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Ciudad */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Ciudad</Form.Label>
                  <Form.Control
                    type="text"
                    name="ciudad"
                    value={filters.ciudad || ''}
                    onChange={handleChange}
                    placeholder="Buscar por ciudad..."
                  />
                </Form.Group>
              </Col>

              {/* Cliente */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Cliente</Form.Label>
                  <Form.Control
                    type="text"
                    name="cliente"
                    value={filters.cliente || ''}
                    onChange={handleChange}
                    placeholder="Nombre del cliente..."
                  />
                </Form.Group>
              </Col>

              {/* Líder (responsable de la OT / programación) */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>
                    {mode === 'programacion' ? 'Líder (programación)' : 'Líder (OT)'}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="lider"
                    value={filters.lider || ''}
                    onChange={handleChange}
                    placeholder="Nombre o apellido..."
                  />
                </Form.Group>
              </Col>
          

            {/* Rango de fechas — Tab 1: fechaInicio | Tab 2: fechaEntrega */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label>
                    {mode === 'programacion' ? 'Fecha Inicio Desde' : 'Fecha Entrega Desde'}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="fechaDesde"
                    value={filters.fechaDesde || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>
                    {mode === 'programacion' ? 'Fecha Inicio Hasta' : 'Fecha Entrega Hasta'}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="fechaHasta"
                    value={filters.fechaHasta || ''}
                    onChange={handleChange}
                    disabled={!filters.fechaDesde}
                    min={filters.fechaDesde || ''}
                  />
                  {!filters.fechaDesde && (
                    <Form.Text className="text-muted">Selecciona primero "Desde"</Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* Acciones */}
            <Row>
              <Col className="d-flex justify-content-end gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={onResetFilters}
                  disabled={activeCount === 0}
                >
                  🗑️ Limpiar filtros
                </Button>
              </Col>
            </Row>
          </Form>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

FiltrosProgramaciones.propTypes = {
  filters:        PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  mode:           PropTypes.oneOf(['programacion', 'ot'])
};

export default FiltrosProgramaciones;
